var _g, _path, _g2, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutubeLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_6575_47101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.882 46.0868C34.0504 51.8855 22.95 51.2413 15.8578 44.1435C8.0474 36.3327 8.0474 23.6688 15.8578 15.8581C23.6682 8.04731 36.3265 8.04731 44.1422 15.8581C51.9526 23.6688 51.9526 36.3276 44.1422 44.1383",
    stroke: "#E93B2E",
    strokeWidth: 2.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.882 46.0868C34.0504 51.8855 22.95 51.2413 15.8578 44.1435C8.0474 36.3327 8.0474 23.6688 15.8578 15.8581C23.6682 8.04731 36.3265 8.04731 44.1422 15.8581C51.9526 23.6688 51.9526 36.3276 44.1422 44.1383",
    stroke: "#E93B2E",
    strokeWidth: 2.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_6575_47101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.7253 27.503C40.7253 24.7674 38.9458 22.7449 36.2156 22.7449H23.7421C21.0119 22.7449 18.1074 24.7727 18.1074 27.503V33.1962C18.1074 35.9318 21.0066 38.2184 23.7421 38.2184H36.2156C38.951 38.2184 40.7253 35.9318 40.7253 33.1962V27.503ZM33.8602 31.2787L28.0038 34.0833C27.782 34.2048 26.842 34.0407 26.842 33.7873V28.0203C26.842 27.7668 27.7873 27.6032 28.0091 27.73L33.5328 30.6877C33.7652 30.8197 34.0925 31.1468 33.8602 31.2736V31.2787Z",
    stroke: "#E93B2E",
    strokeWidth: 3.01,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7253 27.503C40.7253 24.7674 38.9458 22.7449 36.2156 22.7449H23.7421C21.0119 22.7449 18.1074 24.7727 18.1074 27.503V33.1962C18.1074 35.9318 21.0066 38.2184 23.7421 38.2184H36.2156C38.951 38.2184 40.7253 35.9318 40.7253 33.1962V27.503ZM33.8602 31.2787L28.0038 34.0833C27.782 34.2048 26.842 34.0407 26.842 33.7873V28.0203C26.842 27.7668 27.7873 27.6032 28.0091 27.73L33.5328 30.6877C33.7652 30.8197 34.0925 31.1468 33.8602 31.2736V31.2787Z",
    stroke: "#E93B2E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.882 46.0868C34.0504 51.8855 22.95 51.2413 15.8578 44.1435C8.0474 36.3327 8.0474 23.6688 15.8578 15.8581C23.6682 8.04731 36.3265 8.04731 44.1422 15.8581C51.9526 23.6688 51.9526 36.3276 44.1422 44.1383",
    stroke: "#FF9C99",
    strokeWidth: 0.88,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9208 27.5028C40.9208 24.7671 38.9458 22.5435 36.2103 22.5435H23.7368C21.0066 22.5435 17.9067 24.7671 17.9067 27.5028V33.1959C17.9067 35.9316 21.0066 38.4188 23.7368 38.4188H36.2103C38.9458 38.4188 40.9208 35.9316 40.9208 33.1959V27.5028ZM33.8551 31.2784L28.0988 34.083C27.8771 34.2045 27.0374 34.0405 27.0374 33.787V28.02C27.0374 27.7665 27.8823 27.6029 28.1041 27.7297L33.5805 30.6874C33.8128 30.8194 34.0873 31.1465 33.8602 31.2733L33.8551 31.2784Z",
    stroke: "#FF9C99",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_6575_47101",
    x: 0.879883,
    y: 0.879883,
    width: 58.2402,
    height: 58.24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_6575_47101"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_6575_47101",
    x: 8.60254,
    y: 13.24,
    width: 41.6277,
    height: 34.4834,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_6575_47101"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeLight);
export default __webpack_public_path__ + "static/media/youtube_light.0cf93f4e048d59877a45bc9633e091b5.svg";
export { ForwardRef as ReactComponent };